import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Grid,
  Box,
  Typography,
  IconButton,
  Switch,
  FormGroup,
  Tooltip,
  tooltipClasses,
  Autocomplete,
} from "@mui/material";

import Collapse from "@mui/material/Collapse";
// import IconButton from '@mui/material/IconButton';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { DataGrid } from "@mui/x-data-grid";
import "./AddSpecifications.css";
import CloseIcon from "@mui/icons-material/Close";
import arrowUp from "../../../../assets/icons/arrowup.png";
import arrowDown from "../../../../assets/icons/arrowDown.png";
import AddOption from "./AddOption/AddOption.tsx";
import ArrowUpIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownIcon from "@mui/icons-material/ArrowDownward";
import { useDispatch, useSelector } from "react-redux";
import { saveSpecifications } from "../../../../reduxadmin/Actions";
import AutocompleteComponent from "./../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

import infoIcon from "./../../../../assets/icons/info.png";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";

import AddSubOptionDialog from "./AddOption/AddSubOption/AddSubOptionDialog.tsx";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import axios from "axios";
import { toast } from "react-toastify";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import LoadingView from "../../../components/LoadingView/LoadingView.js";
import ediPencil from "./../../../../assets/icons/editPencil.png";
import EditOption from "./AddOption/EditOption.tsx";

function AddSpecification(props) {
  const { open, onClose } = props;
  const [name, setName] = useState();
  const [nameErr, setnameErr] = useState(false);

  const [vat, setVat] = useState(0);
  const [vatErr, setVatErr] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [basePriceErr, setBasePriceErr] = useState(false);
  const [sd, setSD] = useState(0);
  const [sdErr, setSDErr] = useState(false);
  const [sdPercentage, setSDPercentage] = useState(0);
  const [buttonStyle, setButtonStyle] = useState("");
  const [maxSelection, setMaxSelection] = useState();
  const [minSelection, setMinSelection] = useState();
  const [buttonId, setButtonId] = useState(0);
  const [anyValue, setAnyValue] = useState();
  const [textBox, setTextBox] = useState("");
  const [isAnyVisible, setIsAnyVisible] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [isTextBoxVisible, setIsTextBoxVisible] = useState(false);
  const [isOptionVisible, setIsOptionVisible] = useState(false);
  const [isCountableActive, setIsCountableActive] = useState<boolean>(false);
  const [isSdSwitchActive, setisSdSwitchActive] = useState<boolean>(false);
  const [rows, setRows] = useState([{ id: 1, name: "Cake", price: "$4" }]);
  const dispatch = useDispatch();
  const specifications = useSelector((state) => state.specifications);

  const [VatOnsd, setVatOnsd] = useState(0);
  const [VatOnsdPercentage, setVatOnsdPercentage] = useState(0);

  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const [maxQty, setMaxQty] = useState();
  const [MaxQtyLimitErr, setMaxQtyLimitErr] = useState(false);

  const [customSD, setCustomSD] = useState("");
  const [sdDatas, setsdDatas] = useState([]);
  const [sdAdded, setsdAdded] = useState(null);
  const [SdAmount, setSdAmount] = useState(0);
  const [SdInAmount, setSdInAmount] = useState(0.0);
  const [loadingModal, SetloadingModal] = React.useState(false);
  const handelMaxQty = (e) => {
    if (e.target.value <= 0 && isCountable == true) {
      setMaxQtyLimitErr(true);
    } else {
      setMaxQtyLimitErr(false);
    }
    const maxQuantity = e.target.value;
    setMaxQty(maxQuantity);
  };
  const [minQty, setMinQty] = useState();
  const [MinQtyLimitErr, setMinQtyLimitErr] = useState(false);

  // const handelMinQty = (e) => {

  //   if (e.target.value <= 0 && isCountable == true) {
  //     setMinQtyLimitErr(true);
  //   } else {
  //     setMinQtyLimitErr(false);
  //   }
  //   //setMinQty(props);
  //   //setMinQtyErr(false);
  //   const minQuantity = e.target.value;
  //   console.log('minQuantity',minQuantity)
  //   setMinQty(minQuantity);
  // };


  // const handelMinQty = (e) => {
  //   const value = e.target.value;
  //   if (isCountable && (value === '' || Number(value) <= 0)) {
  //     setMinQtyLimitErr(true);
  //     setMinQty(value);
  //   } else {
  //     setMinQtyLimitErr(false);
  //     setMinQty(value);
  //   }
  // };
  const handelMinQty = (e) => {
    // const value = e.target.value;
    const value = e.target.value.replace(/^0+/, '');
    if (isCountable && (value === '' || Number(value) <= 0)) {
      setMinQtyLimitErr(true);
      setMinQty(value);
    } else {
      setMinQtyLimitErr(false);
      setMinQty(value);
    }
  };


  const [increamentalQty, setIncreamentalQty] = useState();
  const [increamentalLimitErr, setincreamentalLimitErr] = useState(false);
  const [increamentalOverLimitErr, setincreamentalOverLimitErr] = useState(false);
  const handelincreamentalQty = (e) => {

    if (e.target.value <= 0 && isCountable == true) {
      setincreamentalLimitErr(true);
    } else {
      setincreamentalLimitErr(false);
    }

    if (e.target.value > maxQty && isCountable == true) {
      setincreamentalOverLimitErr(true);
    } else {
      setincreamentalOverLimitErr(false);
    }
    const incrementalQuantity = e.target.value;
    setIncreamentalQty(incrementalQuantity);
  };
  //radio button size start
  const radioSpecification = {
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
    },
    "& .MuiTypography-root": {
      fontSize: "16px",
    },
  };
  //radio button size end

  const handleClose = () => {
    onClose();
  };
  //show saved value into Table start

  //show saved value into Table end
  // data preview start here
  useEffect(() => {
    if (props.data !== undefined) {
      console.log(props.data)
      setName(props.data.Header);
      setButtonStyle(props.data.ButtonStyle);
      setAnyValue(props.data.any);
      setTextBox(props.data.TextBox);

      setIsAnyVisible(props.data.ButtonStyle === "Check Box" || props.data.ButtonStyle === "Radio Button");
      setIsTextBoxVisible(props.data.ButtonStyle === "TextBox");
      setIsOptionVisible(
        props.data.ButtonStyle === "Check Box" ||
        props.data.ButtonStyle === "Radio Button" ||
        props.data.ButtonStyle === "Button"
      );

      setRows(
        props.data.options.map((option, index) => ({
          id: index + 1,
          name: option.name,
          price: option.price,
        }))
      );
      console.log(props.data);
    }
  }, [props.data]);
  // useEffect(() => {
  //   if(isAnyVisible === "Radio Button"){

  //   }

  // },[isAnyVisible])

  // data preview end here

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  //show textfield and datagrid based on radio option start
  const handleButtonStyleChange = (event) => {
    setButtonStyle(event.target.value);
    setIsAnyVisible(event.target.value === "Check Box" || event.target.value === "Radio Button");
    setIsButtonVisible(event.target.value === "Button");
    setIsTextBoxVisible(event.target.value === "TextBox");
    setIsOptionVisible(
      event.target.value === "Check Box" ||
      event.target.value === "Radio Button" ||
      event.target.value === "Button"
    );
    if (event.target.value === "Radio Button") {
      setButtonId(3);
      setAnyValue(1);
      setMaxSelection(1);
      setMinSelection(0);
    } else if (event.target.value === "Check Box") {
      setButtonId(4);
      setAnyValue('');
      setMaxSelection('');
      setMinSelection('');
    } else if (event.target.value === "TextBox") {
      setButtonId(6);
    } else {
      setButtonId(5);
    }
  };

  const isActive = isButtonVisible || isTextBoxVisible;
  const [newInclusive, setNewInclusive] = useState(0);

  useEffect(() => {
    if (isActive) {
      setBasePrice(0);
      setVat(0);
      setPercentage(0);
      setSD(0);
      setSDPercentage(0);
      setNewInclusive(0);
      setMinQty(0);
      setMaxQty(0);
      setIncreamentalQty(0);
      setsdEnabled(true);
      setisSdSwitchActive(true);
      setIsCountableActive(true);
    }
  }, [isActive])

  useEffect(() => {
    if (isSdSwitchActive == true) {
      setsdSwitch(false)
      setSD(0);
      setSDPercentage(0);
      setVatOnsd(0)
      setVatOnsdPercentage(0);
    }
  }, [isSdSwitchActive])

  useEffect(() => {
    if (isCountableActive) {
      setIsCountable(false);
    }
  }, [isCountableActive])
  // this will go to post

  const [VatAddedOptionPage, setVatAddedOptionPage] = useState();
  const [VatAddeSpecificationPage, setVatAddSpecificationPage] = useState();

  const [isVatAddedOptionPage, setisVatAddedOptionPage] = useState(false);

  const AddOptionVatCheck = (e) => {
    if (e === "") {
      setisVatAddedOptionPage(false);
    } else {
      setisVatAddedOptionPage(true);
    }
    setVatAddedOptionPage(e);
  };


  function getPercentageOrAmount(amount1: number, amount2: number, mode: string): number | string {
    if (mode === 'percentage') {
      return (amount2 / amount1) * 100; // amount2 is what percentage of amount1
    } else if (mode === 'amount') {
      return (amount1 * amount2) / 100; // amount2% of amount1
    } else {
      return 'Invalid mode';
    }
  }


  const handleSetVat = (e) => {
    const vatAmount = e.target.value;
    setVat(vatAmount);
    props.AddSpecificationVatCheck(vatAmount);
    setVatAddSpecificationPage(vatAmount);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(vatAmount), "percentage").toFixed(2);
    if (value) {
      setPercentage(value);
    }
  };

  // vat percentage
  const handleSetPercentage = (e) => {
    const percentageAmount = e.target.value;

    setPercentage(percentageAmount);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(percentageAmount), "amount").toFixed(2);
    if (value) {
      setVat(value);
    }
  }

  const handleBasePrice = (e) => {
    const baseAmount = e.target.value;
    setBasePrice(baseAmount);
  }

  // const handleInclusive = (amountArray: number[]) => {
  //   const isListOfString = Array.isArray(amountArray) && amountArray.every(item => typeof item === 'string');

  //   if (isListOfString) {
  //     const newArray = amountArray.map((item) => parseFloat(item))
  //     return newArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0.0);
  //   }
  //   return 0;
  // };

  // useEffect(() => {
  //   const vatAM = parseFloat(basePrice) * (parseFloat(percentage) / 100)

  //   const sdAM = parseFloat(basePrice) * (parseFloat(sdPercentage) / 100)

  //   setVat(vatAM)
  //   setSD(sdAM)

  //   const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(sd)
  //   setNewInclusive(value)
  // }, [basePrice])

  // useEffect(() => {
  //   const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(sd)
  //   setNewInclusive(value)
  // }, [vat])

  // useEffect(() => {
  //   const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(sd)
  //   setNewInclusive(value)
  // }, [sd])

  // useEffect(() => {
  //   const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(sd) + parseFloat(VatOnsd)
  //   setNewInclusive(value)
  // }, [VatOnsd])

  // const handleSetSD = (e) => {
  //   const sdAmount = e.target.value;

  //   setSD(sdAmount);

  //   const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdAmount), "percentage").toFixed(2);
  //   if (value) {
  //     setSDPercentage(value);
  //   }
  // };


  // const handleSetSDPercentage = (e) => {
  //   const sdPercentage = e.target.value;
  //   setSDPercentage(sdPercentage);

  //   const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdPercentage), "amount").toFixed(2);

  //   if (value) {
  //     setSD(value);
  //   }
  // };


  // const handleSetVatOnSDPercentage = (e) => {
  //   const sdPercentage = e.target.value;
  //   setVatOnsdPercentage(sdPercentage);

  //   const value = getPercentageOrAmount(parseFloat(sd), parseFloat(sdPercentage), "amount").toFixed(2);

  //   if (value) {
  //     setVatOnsd(value);
  //   }
  // };

  //show textfield and datagrid based on radio option end

  const handleAnyValueChange = (event) => {

    if (buttonId === 3) {

    }
    else {
      setAnyValue(event);
      setMaxSelection(event);
    }
  }

  const handleMinSelectionValueChange = (event) => {
    console.log('minselection', event)
    if (buttonId === 3) {

    }
    else {
      //setAnyValue(event.target.value);
      setMinSelection(event);
    }

  };

  const handleTextBoxChange = (event) => {
    setTextBox(event.target.value);
  };
  const nameFieldValue = (props) => {
    setName(props);
  };

  const textFieldValue = (props) => {
    console.log(props);
  };
  const handleAddOptionSave = (option) => {
    const newRow = {
      id: rows.length + 1,
      name: option.name,
      price: option.price,
    };
    setRows((prevRows) => [...prevRows, newRow]);
  };
  // row re-order functionality start
  const handleRowMove = (rowId, direction) => {
    setRows((prevRows) => {
      const rowIndex = prevRows.findIndex((row) => row.id === rowId);
      const newRow = prevRows[rowIndex];
      const newRows = [...prevRows];

      if (direction === "up" && rowIndex > 0) {
        newRows.splice(rowIndex, 1); // Remove the row from the current position
        newRows.splice(rowIndex - 1, 0, newRow); // Insert the row at the new position
      } else if (direction === "down" && rowIndex < prevRows.length - 1) {
        newRows.splice(rowIndex, 1); // Remove the row from the current position
        newRows.splice(rowIndex + 1, 0, newRow); // Insert the row at the new position
      }

      // Update the ids of the rows based on their new positions
      const updatedRows = newRows.map((row, index) => ({
        ...row,
        id: index + 1,
      }));

      return updatedRows;
    });
  };
  const [switchCheck, setswitchCheck] = useState(false);
  const [hasAddonCheck, setHasAddonCheck] = useState(false);
  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck);
  };
  const handleHasAddonCheck = () => {
    setHasAddonCheck(!hasAddonCheck);
  };
  const [switchCollapsableCheck, setswitchCollapsableCheck] = useState(false);
  const handleswitchCollapsableCheck = () => {
    setswitchCollapsableCheck(!switchCollapsableCheck);
  };
  const [switchIsLinked, setSwitchIsLinked] = useState(false);
  const handleSwitchIsLiked = () => {
    setSwitchIsLinked(!switchIsLinked);
  };
  const [switchUserCanSelectQty, setSwitchUserCanSelectQty] = useState(true);
  const handleUserCanSelectQty = () => {
    setSwitchUserCanSelectQty(!switchUserCanSelectQty);
  };
  console.log("switchIsLinked", switchIsLinked);

  useEffect(() => {
    // setButtonId(3)
    // setButtonStyle("Radio Button");
    // setMinSelection(0)
    // setAnyValue(1);
  }, [])

  const [isCountable, setIsCountable] = useState(false);

  const [vatEnabled, setvatEnabled] = useState(true);
  const [sdEnabled, setsdEnabled] = useState(true);
  const [sdSwitch, setsdSwitch] = useState(false);
  const [vatSwitch, setvatSwitch] = useState(false);



  const handleVatSwitch = () => {
    if (vatSwitch == false) {
      setvatSwitch(true)
      setvatEnabled(false)
    }
    else {
      setvatSwitch(false)
      setvatEnabled(true)
    }
  }
  const handleSDSwitch = () => {
    if (sdSwitch == false) {
      setsdSwitch(true)
      setsdEnabled(false)
    }
    else {
      setsdSwitch(false)
      setsdEnabled(true)
      setSDPercentage(0)
      setSD(0)
    }
  }

  // const handleIsCountable = () => {
  //   //setIsCountable(!isCountable);

  //   if (isCountable == true) {
  //     setIsCountable(false)
  //     if (!!minQty != false) {
  //       setMinQty('')
  //       setMinQtyLimitErr(false)
  //     }
  //     if (!!maxQty != false) {
  //       setMaxQty('')
  //       setMaxQtyLimitErr(false)
  //     }
  //     if (!!increamentalQty != false) {
  //       setIncreamentalQty('')
  //       setincreamentalLimitErr(false)
  //       setincreamentalOverLimitErr(false)
  //     }
  //   }
  //   else if (isCountable == false) {
  //     setIsCountable(!isCountable);
  //     setButtonId(3)
  //   }
  // };


  //   const handleIsCountable = () => {
  //   if (isCountable) {
  //     setIsCountable(false);
  //     if (!!minQty !== false) {
  //       setMinQty('');
  //       setMinQtyLimitErr(false);
  //     }
  //     if (!!maxQty !== false) {
  //       setMaxQty('');
  //       setMaxQtyLimitErr(false);
  //     }
  //     if (!!increamentalQty !== false) {
  //       setIncreamentalQty('');
  //       setincreamentalLimitErr(false);
  //       setincreamentalOverLimitErr(false);
  //     }
  //   } else {
  //     setIsCountable(true);
  //     // If all fields are empty or zero, set defaults
  //     if (!minQty || minQty === '0' || minQty === 0) setMinQty(0);
  //     if (!increamentalQty || increamentalQty === '0' || increamentalQty === 0) setIncreamentalQty(1);
  //     if (!maxQty || maxQty === '0' || maxQty === 0) setMaxQty(999);
  //     setButtonId(3);
  //   }
  // };
  const handleIsCountable = () => {
    if (isCountable) {
      setIsCountable(false);
      setMinQty('');
      setMinQtyLimitErr(false);
      setMaxQty('');
      setMaxQtyLimitErr(false);
      setIncreamentalQty('');
      setincreamentalLimitErr(false);
      setincreamentalOverLimitErr(false);
    } else {
      setIsCountable(true);
      setButtonId(3);
      // Do NOT pre-fill any value here
    }
  };


  useEffect(() => {
    loadOptionByRestaurant();
  }, [isCountable])

  const [hasOption, setHasOption] = useState(false);
  const handleHasOption = () => {
    if (hasOption == false) {
      if (isCountable) {
        setButtonId(3)
        setHasOption(true)
        setIsAnyVisible(true);
        setIsOptionVisible(true)
        setButtonStyle("Radio Button")
        setAnyValue(1)
        setMinSelection(0)
      }
      else {
        setButtonId(0)
        setButtonStyle("")
        setHasOption(true)
        setIsAnyVisible(true);
        setIsOptionVisible(true)
        setAnyValue("")
        setMinSelection("")
      }
      setHasOption(true)
    }
    else if (hasOption == true) {
      setHasOption(false)
      setIsAnyVisible(false);
      setIsOptionVisible(false)
      setButtonId(0);
      setMaxSelection("")
      setAnyValue("")
      setButtonStyle("")
      setMinSelection("")
    }

  };

  const [switchQuantityCheck, setQuantityCheck] = useState(false);
  const handlesetQuantityCheck = () => {
    setQuantityCheck(!switchQuantityCheck);
  };

  // row re-order functionality end

  //datagrid customization start
  const columns = [
    {
      field: "id",
      headerName: "Rank",
      width: 117,
      headerClassName: "SpecificationHeader",
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#e7e7e9",
            width: "6rem",
            borderRadius: "5px",
            justifyContent: "center",
          }}
        >
          <ArrowDownIcon
            style={{ cursor: "pointer", margin: "auto", width: 16 }}
            onClick={() => handleRowMove(params.row.id, "down")}
          />
          <span>{params.value}</span>
          <ArrowUpIcon
            style={{ cursor: "pointer", margin: "auto", width: 16 }}
            onClick={() => handleRowMove(params.row.id, "up")}
          />
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      width: 210,
      cellClassName: "SpecificationGridSel",
      headerClassName: "SpecificationHeader",
    },
    {
      field: "price",
      headerName: "Price",
      width: 112,
      cellClassName: "SpecificationGridSel",
      headerClassName: "SpecificationHeader",
    },
  ];
  const [sectionDatas, setSectionDatas] = useState([]);


  const loadOptionByRestaurant = async () => {
    if (buttonId == 5) {
      axios
        .get(
          apiAddress +
          "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
          Restauranttoken.id +
          "&buttonType=Button" +
          "&IsCountableChecked=" + isCountable +
          "&isSDChecked=" + sdSwitch
        )
        .then((response) => {
          console.log(response.data);

          var list = [];
          response.data.map((dt, i) => {
            // Format the title with SD and Countable indicators
            const formattedTitle = `${dt.optionName}${dt.isSD ? " | SD applied" : ""
              }${dt.isCountable ? " | Countable" : ""}`;

            var obj = {
              id: dt.id,
              title: formattedTitle,
              originalName: dt.optionName, // Keep original name if needed
              isSD: dt.isSD,
              isCountable: dt.isCountable
            };
            list.push(obj);
          });
          setSectionDatas(list);
        });
    }
    else {
      axios
        .get(
          apiAddress +
          "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
          Restauranttoken.id +
          "&buttonType=Others" +
          "&IsCountableChecked=" + isCountable +
          "&isSDChecked=" + sdSwitch
        )
        .then((response) => {
          console.log(response.data);

          var list = [];
          response.data.map((dt, i) => {
            // Format the title with SD and Countable indicators
            const formattedTitle = `${dt.optionName}${dt.isSD ? " | SD applied" : ""
              }${dt.isCountable ? " | Countable" : ""}`;

            var obj = {
              id: dt.id,
              title: formattedTitle,
              originalName: dt.optionName, // Keep original name if needed
              isSD: dt.isSD,
              isCountable: dt.isCountable
            };
            list.push(obj);
          });
          setSectionDatas(list);
        });
    }
  };



  // const loadOptionByRestaurant = async () => {

  //   if (buttonId == 5) {
  //     axios
  //       .get(
  //         apiAddress +
  //         "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
  //         Restauranttoken.id +
  //         "&buttonType=Button" +
  //         "&IsCountableChecked=" + isCountable +
  //         "&isSDChecked=" + sdSwitch
  //       )
  //       .then((response) => {
  //         console.log(response.data);

  //         var list = [];
  //         // var subOptionList=[];
  //         response.data.map(async (dt, i) => {
  //           var obj = { id: dt.id, title: dt.optionName };
  //           // await loadOptionSuboptionListByOptionI(dt.id)
  //           list.push(obj);
  //         });
  //         setSectionDatas(list);
  //       });
  //   }
  //   else {
  //     axios
  //       .get(
  //         apiAddress +
  //         "/api/AddOnOptionsMaster/GetAddOnOptionsMasterByRestaurantId?restaurantId=" +
  //         Restauranttoken.id +
  //         "&buttonType=Others" +
  //         "&IsCountableChecked=" + isCountable +
  //         "&isSDChecked=" + sdSwitch
  //       )
  //       .then((response) => {
  //         console.log(response.data);

  //         var list = [];
  //         // var subOptionList=[];
  //         response.data.map(async (dt, i) => {
  //           var obj = { id: dt.id, title: dt.optionName };
  //           // await loadOptionSuboptionListByOptionI(dt.id)
  //           list.push(obj);
  //         });
  //         setSectionDatas(list);
  //       });
  //   }
  // };

  useEffect(() => {
    setRowsData([])
    setaddonOptionValue([])
    loadOptionByRestaurant();
  }, [buttonId]);

  const sectioNames = [
    { id: 1, title: "Sauces" },
    { id: 2, title: "Portion size" },
    { id: 3, title: "Toppings" },
  ];

  const addValue = (props) => {
    console.log(props);
    // setAutoCompleteValue(props)
  };
  //datagrid customization end

  // save option Datagrid valu into filteredRows
  const filteredRows = rows.filter((row) => row.name && row.price);

  const [openOptionDialog, setOpenOptionDialog] = useState(false);

  const handleAddOptionClick = () => {
    setOpenOptionDialog(true);
  };

  const [openAddSubOption, setOpenSubOption] = useState(false);
  const AddSubOptionClicked = () => {
    setOpenSubOption(true);
  };

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  //tooltip end

  //Dynamic Table
  function createData(
    id: string,
    OptionName: string,
    BasePrice: number,
    Vat: number,
    InclusivePrice: number,
    MinQty: number,
    MaxQty: number,
    IsCountable: boolean,
    isSd: boolean,
    sdInAmount: number,
    vatOnSDInAmount: number,
    suboption: []
  ) {
    return {
      id,
      OptionName,
      BasePrice,
      Vat,
      InclusivePrice,
      MinQty,
      MaxQty,
      IsCountable,
      isSd,
      sdInAmount,
      vatOnSDInAmount,
      suboption,
    };
  }

  const [maxVal, setMaxVal] = React.useState(0);

  const moveUp = (index) => {
    if (index === 0) return; // Can't move the first row up
    const newRows = [...rowsData];
    [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];

    // Update serial numbers
    newRows[index - 1].rank -= 1;
    newRows[index].rank += 1;
    setRowsData(newRows);
  };

  const moveDown = (index) => {
    if (index === rowsData.length - 1) return; // Can't move the last row down
    const newRows = [...rowsData];
    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];

    // Update serial numbers
    newRows[index + 1].rank += 1;
    newRows[index].rank -= 1;
    setRowsData(newRows);
  }


  function Row(props: { row: ReturnType<typeof createData> }) {
    const { row, idx } = props;
    const [open, setOpen] = React.useState(false);

    const onEditClick = async (props) => {
      setOpenEditOption(true)
      setEditOptionObj(props)
      console.log("props",props);
      }

    const formattedOptionName = `${row.OptionName}${row.isSd ? " | SD applied" : ""
      }${row.IsCountable ? " | Countable" : ""}`;

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>

            <IconButton size="small" onClick={() => moveUp(idx)}>
              <ArrowUpIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
            <span>{row.rank}</span>
            <IconButton size="small" onClick={() => moveDown(idx)}>
              <ArrowDownIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>

          </TableCell>
          {/* <TableCell component="th" scope="row">
            {formattedOptionName}
            <div
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                //onEditClick(params.row.id);
              }}
            >
              <img src={ediPencil} alt="" style={{ width: "1rem" }} />
            </div>
          </TableCell> */}

          <TableCell component="th" scope="row">
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              {formattedOptionName}
              <img
                src={ediPencil}
                alt="edit"
                style={{ width: "1rem", cursor: "pointer" }}
                onClick={() => {
                  onEditClick(row.id);
                }}
              />
            </div>
          </TableCell>
          {/* <TableCell>
          <div
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              //onEditClick(params.row.id);
            }}
          >
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
          </TableCell> */}
          <TableCell align="right">{row.BasePrice}</TableCell>
          <TableCell align="right">{row.Vat}</TableCell>
          <TableCell align="right">{row.sdInAmount}</TableCell>
          <TableCell align="right">{row.vatOnSDInAmount}</TableCell>
          <TableCell align="right">{row.InclusivePrice}</TableCell>
          <TableCell align="right">{row.MinQty}</TableCell>
          <TableCell align="right">{row.MaxQty}</TableCell>
        </TableRow>

        <TableRow>
          {row.suboption.length > 0 ? (
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="h6" gutterBottom component="div">
                    Sub Option
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Option Name</TableCell>
                          <TableCell align="right">Price</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.suboption.map((row) => (
                          <SubOptionRow key={row.suboptionName} row={row} />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Collapse>
            </TableCell>
          ) : (
            ""
          )}
        </TableRow>
      </React.Fragment>
    );
  }
  // function OptionRow(props) {
  //   const { row } = props;
  //   const [open, setOpen] = React.useState(false);

  //   return (
  //     <React.Fragment>
  //       <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
  //         <TableCell>
  //           <IconButton
  //             aria-label="expand row"
  //             size="small"
  //             onClick={() => setOpen(!open)}
  //           >
  //             {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
  //           </IconButton>
  //         </TableCell>
  //         <TableCell component="th" scope="row">
  //           {row.optionName}
  //         </TableCell>
  //         <TableCell align="right">{row.Baseprice}</TableCell>
  //         <TableCell align="right">{row.vat}</TableCell>
  //         <TableCell align="right">{row.inclusivePrice}</TableCell>
  //       </TableRow>

  //       <TableRow>
  //         {
  //           row.suboption.length > 0 ? (
  //             <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
  //               <Collapse in={open} timeout="auto" unmountOnExit>
  //                 <Box sx={{ margin: 1 }}>
  //                   <Typography variant="h6" gutterBottom component="div">
  //                     Sub-Option
  //                   </Typography>
  //                   <TableContainer component={Paper}>
  //                     <Table aria-label="collapsible table">
  //                       <TableHead>
  //                         <TableRow>
  //                           <TableCell>Sub Option Name</TableCell>
  //                           <TableCell align="right">Base Price</TableCell>
  //                           <TableCell align="right">VAT</TableCell>
  //                           <TableCell align="right">Inclusive Price</TableCell>
  //                         </TableRow>
  //                       </TableHead>
  //                       <TableBody>
  //                         {row.suboption.map((row) => (
  //                           <SubOptionRow key={row.suboptionName} row={row} />
  //                         ))}
  //                       </TableBody>
  //                     </Table>
  //                   </TableContainer>

  //                 </Box>
  //               </Collapse>
  //             </TableCell>
  //           ) : ""
  //         }

  //       </TableRow>
  //     </React.Fragment>
  //   );
  // }
  function SubOptionRow(props) {
    const { row } = props;
    // const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell component="th" scope="row">
            {row.subOptionName}
          </TableCell>
          <TableCell align="right">{row.price}</TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  const [rowsData, setRowsData] = useState([]);
  const [addonsData, setAddOnData] = useState([]);
  const [tempRowsData, setTempRowsData] = useState([]);
  const [addonOptionValue, setaddonOptionValue] = useState([]);
  const [radiovalueSD, setRadiovalueSD] = useState("auto");
  const [radiovalue, setRadiovalue] = useState("auto");
  const [isactive, setIsactive] = React.useState(false);


  const [radiovalueVatonSD, setRadiovalueVatonSD] = useState("auto");
  const [customVatonSD, setCustomVatonSD] = useState("");
  const [vatOnSdAdded, setVatOnSdAdded] = useState(null);
  const [VatOnSdAmount, setVatOnSdAmount] = useState(0);
  const [VatOnSdInAmount, setVatOnSdInAmount] = useState(0.0);
  const [vatDatas, setvatDatas] = useState([]);
  const [vatAmount, setVatAmount] = useState(0);
  const [vatOnSdId, setVatOnSdId] = useState(null);
  const [vatOnSdType, setVatOnSdType] = useState(null);
  const [sdType, setSdType] = useState(null);
  const [sdId, setSdId] = useState(null);

  const inAmountVATValue = (props) => {

  };
  const loadOptionSuboptionListByOptionI = async (props) => {
    console.log(props);
    var list = [];
    await Promise.all(
      props.map(async (d, i) => {
        await axios
          .get(
            apiAddress +
            "/api/AddOnOptionsMaster/GetAddOnOptionsMasterWithSubOptionListById?id=" +
            d.id
          )
          .then((response) => {
            console.log(response.data);
            var obj = createData(
              d.id,
              response.data.addOnOptionsMaster.optionName,
              response.data.addOnOptionsMaster.basePrice,
              response.data.addOnOptionsMaster.vaTinPercentage * 0.01 * response.data.addOnOptionsMaster.basePrice,
              response.data.addOnOptionsMaster.priceInclusiveVAT,
              response.data.addOnOptionsMaster.minQuantity,
              response.data.addOnOptionsMaster.maxQuantity,
              response.data.addOnOptionsMaster.isCountable,
              response.data.addOnOptionsMaster.isSD,
              response.data.addOnOptionsMaster.sdInAmount,
              response.data.addOnOptionsMaster.vatOnSDInAmount,

              response.data.addOnSubOptionsMasterList,

            );
            list.push(obj);
          });
      })
    );
    setTempRowsData(list);
    setAddOnData(list);
  };
  console.log(rowsData);
  console.log(addonsData);

  useEffect(() => {
    const initializeSerialNumbers = (data) => {
      return data.map((item, index) => ({
        ...item,
        rank: index + 1 // Start from 1
      }));
    };
    console.log(tempRowsData);

    const dataWithRanks = initializeSerialNumbers(tempRowsData);
    setRowsData(dataWithRanks);
    console.log(rowsData);
  }, [tempRowsData]);

  console.log("row data: ", rowsData);

  useEffect(() => {
    setIsCountableActive(rowsData.some((item) => item.IsCountable));
    setisSdSwitchActive(rowsData.some((item) => item.isSd))
  }, [rowsData]);

  const addonvalue = async (props) => {
    var tempData = [];
    var optionId = [];
    setaddonOptionValue(props)
    console.log("options: ", props);
    props.map((data, index) => {
      // await loadOptionSuboptionListByOptionI(data.id)
      optionId.push(data.id);
    });
    await loadOptionSuboptionListByOptionI(props);
  };
  const [collapseopen, setcollapseopenOpen] = React.useState(false);

  const [insertView, setInsertView] = useState({
    AddOnsMaster: {
      Id: "123",
    },
  });

  const handleSave = async () => {

    var valid = true;
    if (!!name == false) {
      setnameErr(true);
      valid = false;
    }
    if (!!basePrice == false && buttonId != 5) {
      setBasePriceErr(true);
      valid = false;
    }
    if (!!vat == false && buttonId != 5) {
      //setVatErr(true);
      //valid = false;
    }
    if (sdSwitch == true) {
      if (!!sd == false && buttonId != 5) {
        setSDErr(true);
        valid = false;
      }
    }

    if (hasOption == true) {
      if (buttonId == 0) {
        valid = false;
        toast.error("Please select a option button style", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      if (addonOptionValue.length <= 0) {
        valid = false;
        toast.error("Must select options", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      if (anyValue > addonOptionValue.length.toString()) {
        valid = false;
        toast.error("Number of Options Should be equal or more then Max selection", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }

    if (isCountable == true) {
      console.log(minQty)
      console.log(maxQty)
      console.log(increamentalQty)

      // if (parseInt(minQty) <= 0) {
      //   valid = false;
      //   toast.error("Min Qty Can not be 0 or less then 0", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      // if (parseInt(maxQty) <= 0) {
      //   valid = false;
      //   toast.error("Max Qty Can not be 0 or less then 0", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      if (parseInt(minQty) > parseInt(maxQty)) {
        valid = false;
        toast.error("Max Qty Can not be less then Min Qty", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      if (parseInt(increamentalQty) <= 0) {
        valid = false;
        toast.error("Increament Qty Can not be 0 or less then 0", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      if (parseInt(increamentalQty) > parseInt(maxQty)) {
        valid = false;
        toast.error("Increament value Can not be more then Max Value", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      // if ((parseInt(increamentalQty) + parseInt(minQty)) > parseInt(maxQty)) {
      //   valid = false;
      //   toast.error("Max Value can not be less then Min and increament value combained", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
    }


    let vatOnSdId;
    let vatOnSdPercentage;
    let sdId;
    let sdPercentage;
    let sdAmount;

    if (radiovalueSD === 'auto') {
      sdId = sdAdded?.id;
      sdPercentage = null;
      sdAmount = SdAmount;
    } else if (radiovalueSD === 'Specify') {
      sdId = null;
      sdPercentage = parseFloat(SdInAmount);
      sdAmount = SdAmount;
    } else if (radiovalueSD === 'Fixed') {
      sdId = null;
      sdPercentage = null;
      sdAmount = SdAmount;
    }

    if (radiovalueVatonSD === 'auto') {
      vatOnSdId = vatOnSdAdded?.id;
      vatOnSdPercentage = null;
    } else if (radiovalueVatonSD === 'Specify') {
      vatOnSdId = null;
      vatOnSdPercentage = parseFloat(VatOnSdInAmount);
    }



    setopenConfirmaitonModal(false);
    insertView.AddOnsMaster.Id = "123";
    insertView.AddOnsMaster.RestaurantId = Restauranttoken.id;
    insertView.AddOnsMaster.AddOnName = name;
    insertView.AddOnsMaster.IsCollapsibleOption = switchCollapsableCheck;
    insertView.AddOnsMaster.OptionButtonId = buttonId;
    insertView.AddOnsMaster.MaxSelection = anyValue
    console.log(addonOptionValue.length)
    console.log(hasOption)
    console.log(buttonId)
    if (hasOption == true && buttonId == 4) {
      console.log('main if hit')
      if (insertView.AddOnsMaster.MaxSelection == "") {
        console.log('if hit')
        insertView.AddOnsMaster.MaxSelection = addonOptionValue.length;
      }
      else {
        insertView.AddOnsMaster.MaxSelection = anyValue ?? 0;
      }
    }
    else {
      insertView.AddOnsMaster.MaxSelection = anyValue ?? 0;
    }
    insertView.AddOnsMaster.TextBoxName = textBox;
    insertView.AddOnsMaster.CreationId = "123";
    insertView.AddOnsMaster.ModificationId = "123";
    insertView.AddOnsMaster.vaTinPercentage = percentage;

    if (isCountable && minQty === "") {
      insertView.AddOnsMaster.minQuantity = 0;
    }
    else if (isCountable) {
      insertView.AddOnsMaster.minQuantity = minQty ?? 0;
    }
    else if (minQty === "") {
      insertView.AddOnsMaster.minQuantity = 0
    }
    else {
      insertView.AddOnsMaster.minQuantity = minQty ?? 0;
    }

    if (isCountable && maxQty === "") {
      insertView.AddOnsMaster.maxQuantity = 999;
    }
    else if (isCountable) {
      insertView.AddOnsMaster.maxQuantity = maxQty ?? 999;
    }
    else if (maxQty === "") {
      insertView.AddOnsMaster.maxQuantity = 0;
    }
    else {
      insertView.AddOnsMaster.maxQuantity = maxQty ?? 0;
    }

    if (isCountable && increamentalQty === "") {
      insertView.AddOnsMaster.increamentalQuantity = 1;
    }
    else if (isCountable) {
      insertView.AddOnsMaster.increamentalQuantity = increamentalQty ?? 1;
    }
    else if (increamentalQty === "") {
      insertView.AddOnsMaster.increamentalQuantity = 1;
    }
    else {
      insertView.AddOnsMaster.increamentalQuantity = increamentalQty ?? 0;
    }

    //insertView.AddOnsMaster.increamentalQuantity = increamentalQty ?? 1;

    insertView.AddOnsMaster.IsCountable = isCountable;
    insertView.AddOnsMaster.basePrice = basePrice;
    //insertView.AddOnsMaster.sDinPercentage = sdPercentage;
    // insertView.AddOnsMaster.sDinPercentage = SdInAmount;
    insertView.AddOnsMaster.priceInclusiveVAT = newInclusive;

    insertView.AddOnsMaster.minSelection = minSelection

    if (hasOption == true && buttonId == 4) {

      if (!!insertView.AddOnsMaster.minSelection) {

        insertView.AddOnsMaster.minSelection = minSelection ?? 0;
      }
      else {

        insertView.AddOnsMaster.minSelection = 0;
      }
    }
    else {
      console.log('else hit')
      insertView.AddOnsMaster.minSelection = minSelection ?? 0;
    }


    // insertView.AddOnsMaster.vatInSDPercentage = VatOnsdPercentage;
    //insertView.AddOnsMaster.vatInSDPercentage = VatOnSdInAmount;



    insertView.AddOnsMaster.vatOnSDId = vatOnSdId;
    insertView.AddOnsMaster.vatOnSDType = radiovalueVatonSD;
    insertView.AddOnsMaster.sdId = sdId;
    insertView.AddOnsMaster.SDType = radiovalueSD;
    insertView.AddOnsMaster.sDinPercentage = sdPercentage;
    insertView.AddOnsMaster.sdInAmount = sdAmount;
    insertView.AddOnsMaster.vatInSDPercentage = vatOnSdPercentage;
    insertView.AddOnsMaster.isSD = isSdSwitchActive;

    console.log(rowsData)

    var mapperlist = [];
    await rowsData.map((dt, i) => {
      if (dt.suboption.length > 0) {
        dt.suboption.map((d, i) => {
          var obj = {
            id: "string",
            addOnId: "string",
            optionId: dt.id,
            subOptionId: d.id,
            creationId: "string",
          };
          mapperlist.push(obj);
        });
      }
      else {
        var obj = {
          id: "string",
          addOnId: "string",
          optionId: dt.id,
          subOptionId: "string",
          creationId: "string",
        };
        mapperlist.push(obj);
      }
    });

    insertView.AddOnOptionSubOptionMasterMapperList = mapperlist;

    console.log("insert view: ", insertView);

    if (valid) {
      SetloadingModal(true);
      var url = apiAddress + "/api/AddOns/CreateAddOnsMaster";
      await axios.post(url, insertView).then((response) => {
        console.log(response.data);
        toast.success("Succesfully Submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        SetloadingModal(false);
        props.reloadAddons();
        // setButtonStyle('')
        onClose();
      });
    }
  };

  const ReloadOption = () => {
    loadOptionByRestaurant();
  };

  useEffect(() => {
    if (minQty > 0 || maxQty > 0 || increamentalQty > 0) {
      if (isCountableActive == false) {
        setIsCountable(true);
      } else {
        setIsCountable(false);
        setMaxQtyLimitErr(false)
        setMinQtyLimitErr(false)
        setincreamentalLimitErr(false)
        setincreamentalOverLimitErr(false)

      }

    }
    else if (minQty === 0 || maxQty === 0 || increamentalQty === 0) {
      setIsCountable(false);
    }
    else {
      setIsCountable(false);
    }
  }, [minQty, maxQty, increamentalQty])


  const handleRadioChangeSD = (event) => {
    const value = event.target.value;
    setRadiovalueSD(value);
    setSdType(value); // Set the SD type

    if (value === "Specify") {
      setsdAdded(null);
      setCustomSD("");
      setSdId(null);
      setSdAmount(0);
    } else if (value === "auto") {
      setCustomSD("");
      setSdAmount(0);
      setSdId(sdAdded?.id || null);
    } else if (value === "Fixed") {
      setSdAmount(0);
      setSdInAmount("");
      setSdId(null);
    }
  };
  const inAmountSDValue = (props) => {

    if (radiovalueSD === "Specify") {

    }
    else if (radiovalueSD === "auto") {

    }
    else if (radiovalueSD === "Fixed") {
      setSdAmount(props)
    }
    //setSdAmount(props)
  };

  const inPercentageVATValue = (props) => {

  };


  useEffect(() => {
    axios
      .get(
        apiAddress +
        "/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=" + Restauranttoken?.id
      )
      .then((response) => {
        var list = [];
        response.data?.map((dt, i) => {
          var obj =
          {
            id: dt.id,
            title: dt.name,
            percentage: dt.percentage
          };
          list.push(obj);
        });
        setvatDatas(list);
      });
  }, []);








  const handleRadioChangeVatOnSD = (event) => {
    const value = event.target.value;
    setRadiovalueVatonSD(value);
    setVatOnSdType(value); // Set the VAT on SD type

    if (value === "Specify") {
      setVatOnSdAdded(null);
      setCustomVatonSD("");
      setVatOnSdId(null);
    } else {
      setCustomVatonSD("");
      setVatOnSdId(vatOnSdAdded?.id || null);
    }
  };


  useEffect(() => {
    if (sdAdded && sdAdded.percentage) {
      setIsactive(false);
      setSdInAmount(sdAdded.percentage);

      var sdPrice = sdAdded.percentage / 100
      var total = sdPrice * basePrice;
      setSdAmount(total.toFixed(2));
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else if (customSD) {
      setSdInAmount(customSD);
      var vatPrice = customSD / 100
      var total = vatPrice * basePrice;
      setSdAmount(total.toFixed(2));
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else {
      setSdInAmount(0);
      setSdAmount(0);
      //setpriceInclusive(0)
    }
  }, [sdAdded, customSD]);

  // useEffect(() => {
  //   const vatAM = parseFloat(basePrice) * (parseFloat(percentage) / 100)

  //   const sdAM = parseFloat(basePrice) * (parseFloat(sdPercentage) / 100)

  //   const vatonsdAM = parseFloat(sdAM) * (parseFloat(VatOnsdPercentage) / 100)

  //   setVatAmount(vatAM.toFixed(2))
  //   setSdAmount(sdAM.toFixed(2))
  //   setVatOnSdAmount(vatonsdAM.toFixed(2))

  //   const value = parseFloat(basePrice) + parseFloat(vatAmount) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
  //   setNewInclusive(value.toFixed(2))
  // }, [basePrice])

  useEffect(() => {
    const value = parseFloat(basePrice) + parseFloat(vatAmount) + parseFloat(SdAmount)
    setNewInclusive(value.toFixed(2))
  }, [vatAmount])

  useEffect(() => {
    const value = parseFloat(basePrice) + parseFloat(vatAmount) + parseFloat(SdAmount)
    setNewInclusive(value.toFixed(2))
  }, [SdAmount])



  useEffect(() => {
    if (vatOnSdAdded && vatOnSdAdded.percentage) {
      setIsactive(false);
      setVatOnSdInAmount(vatOnSdAdded.percentage);

      var sdPrice = vatOnSdAdded.percentage / 100
      var total = sdPrice * SdAmount;
      setVatOnSdAmount(total.toFixed(2));
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else if (customVatonSD) {
      setVatOnSdInAmount(customVatonSD);
      var vatPrice = customVatonSD / 100
      var total = vatPrice * SdAmount;
      setVatOnSdAmount(total.toFixed(2));
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else {
      setVatOnSdInAmount(0);
      setVatOnSdAmount(0);
      //setpriceInclusive(0)
    }
  }, [vatOnSdAdded, customVatonSD]);

  useEffect(() => {
    const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setNewInclusive(value.toFixed(2))
  }, [VatOnSdAmount])




  // Replace all the existing useEffect hooks for price calculations with this single one:
  useEffect(() => {
    const base = parseFloat(basePrice) || 0;
    const vatPerc = parseFloat(percentage) || 0;
    const sdPerc = parseFloat(SdInAmount) || 0;
    const vatOnSdPerc = parseFloat(VatOnSdInAmount) || 0;

    // Calculate all amounts
    const vatAmount = (base * vatPerc) / 100;
    const sdAmount = radiovalueSD === 'Fixed' ? parseFloat(SdAmount) : (base * sdPerc) / 100;
    const vatOnSdAmount = (sdAmount * vatOnSdPerc) / 100;

    // Update state
    setVat(vatAmount.toFixed(2));
    setSD(sdAmount.toFixed(2));
    setVatOnSdAmount(vatOnSdAmount.toFixed(2));

    // Calculate inclusive price
    const inclusive = base + vatAmount + sdAmount + vatOnSdAmount;
    setNewInclusive(inclusive.toFixed(2));
  }, [basePrice, percentage, SdInAmount, VatOnSdInAmount, radiovalueSD, SdAmount]);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const [OpenEditOption, setOpenEditOption] = useState(false);
  const [EditOptionObj, setEditOptionObj] = useState(false);

  const handleEditOptionClose = () => {
    setOpenEditOption(false)
  };

  const handleOptionCloseOnSuccess = () => {
    setOpenEditOption(false)
    loadOptionByRestaurant()
  };

  console.log(isVatAddedOptionPage, "isVatAddedOptionPage");
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className=""
      fullWidth={true}
      maxWidth={"lg"}
    >
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to save this?"}
        open={openConfirmaitonModal}
        onyes={handleSave}
        close={() => {
          setopenConfirmaitonModal(false);
        }}
      />
      <DialogTitle disableTypography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" className="textColor">
            {props.dialogName}
          </Typography>
          <IconButton
            aria-label="close"
            className="closeButton"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className="textColor">
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Addon Name</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextAreaComponents label={"Name"} value={nameFieldValue} />
            {nameErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
          </Grid>

        </Grid>
        {/* <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Collapse option list</Typography>
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">
                    Use this option to auto-hide the add-on options so that the
                    user can scroll through all the main add-ons quicker. By
                    default, this is set to Auto, and the add-on option list
                    auto-collapses if there are more than 5 options in the list.
                    If it is set to Yes, the option list is always collapsed
                  </Typography>
                </React.Fragment>
              }
            >
              <InfoOutlinedIcon style={{ color: "#371B17" }} />
            </HtmlTooltip>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={switchCollapsableCheck}
              onChange={handleswitchCollapsableCheck}
              inputProps={{ "aria-label": "controlled" }}
            />
            {switchCollapsableCheck ? "Yes" : "Auto"}
          </Grid>
        </Grid>

        {props?.openFrom === "AddItemDialog" ? (
          <Grid
            container
            className="gridSpecificationContainer"
            spacing={3}
            alignItems="center"
          >
            <Grid item xs={3}>
              <Typography className="textColor">Is Linked</Typography>
            </Grid>
            <Grid item xs={9}>
              <Switch
                checked={switchIsLinked}
                onChange={handleUserCanSelectQty}
                inputProps={{ "aria-label": "controlled" }}
              />
              {switchIsLinked ? "Yes" : "No"}
            </Grid>
          </Grid>
        ) : (
          ""
        )} */}

        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Base Price</Typography>
          </Grid>
          <Grid item xs={9}>
            {/* <TextAreaComponents
              label={"Base Price"}
              value={handleBasePrice}
              val={basePrice}
              id={2}
              isactive={isActive}
            /> */}

            <TextField
              placeholder={"Base Price"}
              onChange={(e) => { handleBasePrice(e) }}
              value={basePrice}
              fullWidth
              type="number"
              disabled={isActive}
              inputProps={{
                style: {
                  cursor: isActive ? "not-allowed" : "text",
                },
              }}
            />
            {basePriceErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">VAT</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
            {/* <Grid item xs={1} style={{ paddingTop: "1.5rem" }}>
            <Switch
              checked={vatSwitch}
              onChange={handleVatSwitch}
              inputProps={{ "aria-label": "controlled" }}
              disabled={isCountableActive}
            />
            </Grid> */}

            <Grid item xs={6}>
              <TextField
                placeholder={"VAT percentage"}
                onChange={(e) => { handleSetPercentage(e) }}
                value={percentage}
                fullWidth
                type="number"
                disabled={isActive}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
              {isVatAddedOptionPage === true ? (
                <span style={{ color: "red" }}>Vat Added in Option Page</span>
              ) : (
                ""
              )}
            </Grid>

            <Grid item xs={6}>
              <TextField
                placeholder="VAT amount"
                onChange={(e) => handleSetVat(e)}
                value={vat}
                type="number"
                fullWidth
                disabled={vatEnabled}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
              {vatErr && (
                <span style={{ color: "red" }}>This field is required</span>
              )}

              {isVatAddedOptionPage === true ? (
                <span style={{ color: "red" }}>Vat Added in Option Page</span>
              ) : (
                ""
              )}

            </Grid>
          </Grid>
        </Grid>
        {/* <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">SD</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>

            <Grid item xs={1} style={{ paddingTop: "1.5rem" }}>
              <Switch
                checked={sdSwitch}
                onChange={handleSDSwitch}
                inputProps={{ "aria-label": "controlled" }}
                disabled={isSdSwitchActive}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                placeholder={"SD percentage"}
                onChange={(e) => { handleSetSDPercentage(e) }}
                value={sdPercentage}
                fullWidth
                type="number"
                disabled={sdEnabled}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />

              {isVatAddedOptionPage === true ? (
                <span style={{ color: "red" }}>SD Added in Option Page</span>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={6}>
              <TextField
                placeholder={"SD amount"}
                onChange={(e) => { handleSetSD(e) }}
                value={sd}
                fullWidth
                type="number"
                disabled={sdEnabled}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
              {sdErr && (
                <span style={{ color: "red" }}>This field is required</span>
              )}

              {isVatAddedOptionPage === true ? (
                <span style={{ color: "red" }}>SD Added in Option Page</span>
              ) : (
                ""
              )}

            </Grid>
          </Grid>
        </Grid> */}


        <Grid container className="gridSpecificationContainer" spacing={5} alignItems="center">
          <Grid item xs={3}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography className="textColor">SD</Typography>
              <Switch
                checked={sdSwitch}
                onChange={handleSDSwitch}
                inputProps={{ "aria-label": "controlled" }}
                disabled={isSdSwitchActive}
              />
            </Box>
          </Grid>

          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={12}>
              <RadioGroup
                row
                name="sd-radio-buttons-group"
                value={radiovalueSD}
                onChange={handleRadioChangeSD}
              >
                <FormControlLabel value="auto" control={<Radio />} label="Select from SD List" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Specify" control={<Radio />} label="Specify SD" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Fixed" control={<Radio />} label="Fixed SD" />
              </RadioGroup>
            </Grid>

            {radiovalueSD === "auto" && (
              <Grid item xs={4}>
                <Autocomplete
                  id="free-solo-with-text-demo"
                  options={vatDatas}
                  value={sdAdded}
                  onChange={(event, newInputValue) => {
                    setsdAdded(newInputValue);
                    setSdId(newInputValue?.id || null); // Set the SD ID when selected
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  disabled={sdEnabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select SD"
                      disabled={radiovalueSD !== "auto"}
                    />
                  )}
                />
              </Grid>
            )}

            {radiovalueSD === "Specify" && (
              <Grid item xs={4}>
                <TextField
                  placeholder="Specify SD Percentage"
                  variant="outlined"
                  value={customSD}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setCustomSD(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  type="number"
                  disabled={sdEnabled}
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="SD (%)"
                value={inPercentageVATValue}
                val={SdInAmount !== 0 ? SdInAmount : ""}
                isactive={isactive}
                placeholder="SD (%)"
                disabled={sdEnabled}
              />
              {vatErr && <span style={{ color: "red" }}>This field is required</span>}
            </Grid>

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="SD (Amount)"
                value={inAmountSDValue}
                val={SdAmount}
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>
          </Grid>
        </Grid>



        <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
          <Grid item xs={3}>
            <Typography className="textColor">VAT On SD</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={12}>
              <RadioGroup
                row
                name="vat-sd-radio-buttons-group"
                value={radiovalueVatonSD}
                onChange={handleRadioChangeVatOnSD}

              >
                <FormControlLabel value="auto" control={<Radio />} label="Select from VAT List" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Specify" control={<Radio />} label="Specify VAT On SD" />
              </RadioGroup>
            </Grid>

            {radiovalueVatonSD === "auto" && (
              <Grid item xs={4}>
                <Autocomplete
                  id="select-vat"
                  options={vatDatas}
                  value={vatOnSdAdded}
                  onChange={(event, newInputValue) => {
                    setVatOnSdAdded(newInputValue);
                    setVatOnSdId(newInputValue?.id || null); // Set the VAT on SD ID when selected
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select VAT"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  disabled={sdEnabled}
                />
              </Grid>
            )}

            {radiovalueVatonSD === "Specify" && (
              <Grid item xs={4}>
                <TextField
                  placeholder="Specify VAT (%)"
                  variant="outlined"
                  value={customVatonSD}
                  type="number"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setCustomVatonSD(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  disabled={sdEnabled}
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="VAT (%)"
                value={inPercentageVATValue}
                val={VatOnSdInAmount !== 0 ? VatOnSdInAmount : ""}
                isactive={isactive}
                placeholder="VAT (%)"
                disabled={sdEnabled}
              />
              {vatErr && <span style={{ color: "red" }}>This field is required</span>}
            </Grid>

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="VAT (Amount)"
                value={inAmountVATValue}
                val={VatOnSdAmount}
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>
          </Grid>
        </Grid>




        {/* <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Vat on SD</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={6}>
              <TextField
                placeholder={"SD percentage"}
                onChange={(e) => { handleSetVatOnSDPercentage(e) }}
                value={VatOnsdPercentage}
                fullWidth
                type="number"
                disabled={sdEnabled}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />

              {isVatAddedOptionPage === true ? (
                <span style={{ color: "red" }}>SD Added in Option Page</span>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={6}>
              <TextField
                placeholder={"SD amount"}
                onChange={(e) => { handleSetSD(e) }}
                value={VatOnsd}
                fullWidth
                type="number"
                disabled={sdEnabled}
                inputProps={{
                  style: {
                    cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                  },
                }}
              />
              {sdErr && (
                <span style={{ color: "red" }}>This field is required</span>
              )}

              {isVatAddedOptionPage === true ? (
                <span style={{ color: "red" }}>SD Added in Option Page</span>
              ) : (
                ""
              )}

            </Grid>
          </Grid>
        </Grid> */}

        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Inclusive</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              placeholder={"Inclusive"}
              value={newInclusive}
              fullWidth
              type="number"
              disabled={isActive}
              inputProps={{
                style: {
                  cursor: isActive ? "not-allowed" : "text", // Directly apply the cursor style here
                },
              }}
            />
          </Grid>
        </Grid>

        {/* <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              Is countable
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={isCountable}
              onChange={handleIsCountable}
              inputProps={{ "aria-label": "controlled" }}
              disabled={isCountableActive}
            />
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">
                    Entry "Min Qty","Max Qty" and "Increament Qty" To enable Is Countable
                  </Typography>
                </React.Fragment>
              }
            >
              <InfoOutlinedIcon style={{ color: "#371B17" }} />
            </HtmlTooltip>
          </Grid>
        </Grid> */}


        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              Has Option
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={hasOption}
              onChange={handleHasOption}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>
        </Grid>

        {hasOption && (
          <>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={3}
              alignItems="center"
            >
              <Grid item xs={3}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Option button style</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          If this add-on has an option list (for examle the
                          add-on named 'Sauces' can have options 'salsa sauce',
                          cheese sauce, etc), then select the type of button the
                          user clicks on to select each option
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
                </div>
              </Grid>
              <Grid item xs={9}>
                <RadioGroup
                  aria-label="buttonStyle"
                  name="buttonStyle"
                  value={buttonStyle}
                  onChange={handleButtonStyleChange}
                  row
                >
                  <FormControlLabel
                    value="Radio Button"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" className="textColor">
                        Radio Button
                      </Typography>
                    }
                    sx={radioSpecification}
                  />
                  <FormControlLabel
                    value="Check Box"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" className="textColor">
                        Check Box
                      </Typography>
                    }
                    sx={radioSpecification}
                  />
                  <FormControlLabel
                    value="Button"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" className="textColor">
                        Button
                      </Typography>
                    }
                    sx={radioSpecification}
                    disabled={isCountable}
                  />
                  <FormControlLabel
                    value="TextBox"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" className="textColor">
                        TextBox
                      </Typography>
                    }
                    sx={radioSpecification}
                    disabled={isCountable}
                  />
                </RadioGroup>
              </Grid>
            </Grid>
          </>
        )}
        {isAnyVisible && (
          <>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={2}
              alignItems="center"
            >
              <Grid item xs={3}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Min Selection</Typography>
                  {buttonId == 3 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            If button type is "Radio Button" then Min selection will Always be 0.
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "FF0000" }} />
                    </HtmlTooltip>
                  )}
                  {buttonId == 4 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Restrict the maximum number of different add-on
                            options the user can select. For example, if the
                            add-on is 'Sauce' and the options are 'Salsa',
                            'Cheese' or 'Tomato', you can restrict the selection
                            to 1, and the user can only select 1of either sauce
                            options and no more (if you allow the user to set the
                            quantity he needs, then this will still apply, for
                            example, 3 'Tomato' sauce sachets)
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "#371B17" }} />
                    </HtmlTooltip>
                  )}
                </div>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents
                  id={2}
                  label={"Min Selection"}
                  value={handleMinSelectionValueChange}
                  val={minSelection}
                />
              </Grid>
            </Grid>
          </>
        )}
        {isAnyVisible && (
          <>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={2}
              alignItems="center"
              style={{ marginTop: "-1rem" }}
            >
              <Grid item xs={3}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "0rem", gap: "10px" }}
                >
                  <Typography>Max Selection</Typography>
                  {buttonId == 3 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            If button type is "Radio Button" then user will only be able to select maximun 1 option.
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "FF0000" }} />
                    </HtmlTooltip>
                  )}
                  {buttonId == 4 && (
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            Restrict the maximum number of different add-on
                            options the user can select. For example, if the
                            add-on is 'Sauce' and the options are 'Salsa',
                            'Cheese' or 'Tomato', you can restrict the selection
                            to 1, and the user can only select 1of either sauce
                            options and no more (if you allow the user to set the
                            quantity he needs, then this will still apply, for
                            example, 3 'Tomato' sauce sachets)
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoOutlinedIcon style={{ color: "#371B17" }} />
                    </HtmlTooltip>
                  )}
                </div>
              </Grid>
              <Grid item xs={9}>
                <TextAreaComponents
                  id={2}
                  label={"Max Selection"}
                  value={handleAnyValueChange}
                  val={anyValue}
                />
              </Grid>
            </Grid>
          </>
        )}
        {isTextBoxVisible && (
          <Grid
            container
            className="gridSpecificationContainer"
            spacing={3}
            alignItems="center"
          >
            <Grid item xs={3}>
              <Typography className="textColor">Text Box Name</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                label="Complimentary"
                value={textBox}
                onChange={handleTextBoxChange}
                fullWidth
                margin="normal"
              />
            </Grid>
          </Grid>
        )}
        {isOptionVisible && (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3} style={{ margin: "0 auto auto" }}>
              <Typography className="textColor">Option</Typography>
            </Grid>
            <Grid item xs={9}>
              <Grid container sx={{ alignItems: "center" }} spacing={2}>
                <Grid item xs={10}>
                  <AutocompleteComponent
                    label={""}
                    placeholder={"Add Option"}
                    value={addonvalue}
                    datas={sectionDatas}
                    val={addonOptionValue}
                    id={2}
                  />
                </Grid>
                <Grid item xs={2}>
                  <div className="d-flex TooltipClass align-items-center">
                    <Typography
                      className="textColor"
                      onClick={handleAddOptionClick}
                    >
                      +Add Option
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              {openOptionDialog ? (
                <AddOption
                  open={openOptionDialog}
                  onClose={() => setOpenOptionDialog(false)}
                  reloadOption={ReloadOption}
                  onSave={handleAddOptionSave}
                  AddOptionVatCheck={AddOptionVatCheck}
                  isVatAddedSpecificationPage={
                    props.isVatAddedSpecificationPage
                  }
                  switchIsLinked={switchIsLinked}
                />
              ) : (
                ""
              )}
              <br></br>
              <div style={{ width: "100%" }}>
                {/* <DataGrid
                  columns={columns}
                  rows={filteredRows}
                  disableColumnMenu
                  disableSelectionOnClick
                  hideFooterPagination
                  rowReordering
                  headerHeight={48}
                  rowHeight={48}
                /> */}
                {rowsData.length > 0 && hasOption ? (
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell>AddOn Name</TableCell>
                          <TableCell align="right">BasePrice</TableCell>
                          <TableCell align="right">Vat</TableCell>
                          <TableCell align="right">SD</TableCell>
                          <TableCell align="right">Vat On SD</TableCell>
                          <TableCell align="right">InclusivePrice</TableCell>
                          <TableCell align="right">Min Qty</TableCell>
                          <TableCell align="right"> Max Qty</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowsData.map((row, idx) => (
                          <Row key={row.name} row={row} idx={idx} />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  ""
                )}
              </div>
            </Grid>
          </Grid>
        )}

        
      </DialogContent>
      <DialogActions>
        <Button
          className="textColor btn"
          onClickCapture={() => setopenConfirmaitonModal(true)}
        >
          Save
        </Button>
      </DialogActions>

      {OpenEditOption &&
        <EditOption
          open={OpenEditOption}
          handleEditOptionClose={handleEditOptionClose}
          editData={EditOptionObj}
          onOptionModelClose={handleOptionCloseOnSuccess}
        />}
    </Dialog>
  );
}

export default AddSpecification;
